import placeholderBanner from '../../../../assets/images/banner.png';
import placeholderEventTicketBanner from '../../../../assets/images/event-ticket-banner.png';
import placeholderIcon from '../../../../assets/images/icon.png';
import placeholderLogo from '../../../../assets/images/logo.png';

import {
  FieldSection,
  TemplateState,
  TemplatePreset,
  PreviewData,
} from '../../../../store/types/template';

export function hasLocalisationFields(template: TemplateState) {
  const fieldsToCheck = ['header', 'central', 'details', 'back'];

  return fieldsToCheck.some((fieldType) => {
    const fieldSection = template?.fields?.[fieldType as FieldSection];
    if (!fieldSection || typeof fieldSection !== 'object') {
      return false;
    }

    return Object.values(fieldSection).some((field) => {
      return (
        field &&
        typeof field === 'object' &&
        field.localisation &&
        typeof field.localisation === 'object' &&
        Object.keys(field.localisation).length > 0
      );
    });
  });
}

export function normalizedData(data: any[], included: any[] = []) {
  const dynamicFormByTemplateId = (included || []).reduce(
    (acc: Record<string, boolean>, inc: any) => {
      if (inc.type === 'dynamicFormTemplate' && inc.attributes?.templateId) {
        acc[inc.attributes.templateId] = true;
      }
      return acc;
    },
    {}
  );

  const hasDynamicForm = (item: any) =>
    item.attributes?.hasDynamicForm === true ||
    dynamicFormByTemplateId[item.id] === true;

  if (data?.length > 0) {
    return data.map((item: any) => ({
      ...item.attributes,
      processingStatus: item.attributes.processingStatus,
      status: item.attributes.status,
      bodyFontColor: item.attributes.colors?.text,
      templateName: item.attributes.name,
      passBackgroundColor: item.attributes.colors?.background,
      titleFontColor: item.attributes.colors?.label,
      uuid: item.id,
      passType: item.attributes.templateType,
      headerOneId: item.attributes.fields?.header?.one?.id,
      headerOneLabel: item.attributes.fields?.header?.one?.label,
      headerOneValue: item.attributes.fields?.header?.one?.defaultValue,
      primaryOneId: item.attributes.fields?.central?.one?.id,
      primaryOneLabel: item.attributes.fields?.central?.one?.label,
      primaryOneValue: item.attributes.fields?.central?.one?.defaultValue,
      primaryTwoId: item.attributes.fields?.central?.two?.id,
      primaryTwoLabel: item.attributes.fields?.central?.two?.label,
      primaryTwoValue: item.attributes.fields?.central?.two?.defaultValue,
      detailsOneId: item.attributes.fields?.details?.one?.id,
      detailsOneLabel: item.attributes.fields?.details?.one?.label,
      detailsOneValue: item.attributes.fields?.details?.one?.defaultValue,
      detailsTwoId: item.attributes.fields?.details?.two?.id,
      detailsTwoLabel: item.attributes.fields?.details?.two?.label,
      detailsTwoValue: item.attributes.fields?.details?.two?.defaultValue,
      detailsThreeId: item.attributes.fields?.details?.three?.id,
      detailsThreeLabel: item.attributes.fields?.details?.three?.label,
      detailsThreeValue: item.attributes.fields?.details?.three?.defaultValue,
      description: item.attributes.description,
      detailsFourId: item.attributes.fields?.details?.four?.id,
      detailsFourLabel: item.attributes.fields?.details?.four?.label,
      detailsFourValue: item.attributes.fields?.details?.four?.defaultValue,
      detailsFiveId: item.attributes.fields?.details?.five?.id,
      detailsFiveLabel: item.attributes.fields?.details?.five?.label,
      detailsFiveValue: item.attributes.fields?.details?.five?.defaultValue,
      detailsSixId: item.attributes.fields?.details?.six?.id,
      detailsSixLabel: item.attributes.fields?.details?.six?.label,
      detailsSixValue: item.attributes.fields?.details?.six?.defaultValue,
      inList: true,
      cutoutBg: '#F8F8F8',
      editUrl: `/pass-templates/edit/${item.id}`,
      logoImage:
        item.attributes.images?.logo ||
        item.attributes.images?.apple?.logo ||
        placeholderLogo,
      iconLogo: item.attributes.images?.icon ?? placeholderIcon,
      googleLogoImage: item.attributes.images?.google?.logo ?? null,
      bannerImage:
        item.attributes.images?.banner ??
        item.attributes.images?.apple?.banner ??
        (item.attributes.templateType === 'eventTicket'
          ? placeholderEventTicketBanner
          : item.attributes.templateType === 'generic'
            ? null
            : placeholderBanner),
      googleBannerImage: item.attributes.images?.google?.banner ?? null,
      thumbnailImage: !item.attributes.images?.apple?.thumbnail
        ? item.attributes.templateType === 'generic'
          ? null
          : placeholderIcon
        : item.attributes.images?.apple?.thumbnail,
      appleAppLink: item.attributes.appLinking?.apple?.appStoreUrl,
      locations: item.attributes.locations,
      beacons: item.attributes.beacons,
      displayBannerWatermarkPreview: true,
      displayGoogleBannerWatermarkPreview: true,
      watermarkColor:
        item.attributes.images?.apple?.watermark?.color ||
        item.attributes.images?.watermark?.color,
      watermarkPosition:
        item.attributes.images?.apple?.watermark?.position ||
        item.attributes.images?.watermark?.position,
      googleBannerWatermarkColor:
        item.attributes.images?.google?.watermark?.color ||
        item.attributes.images?.watermark?.color,
      googleBannerWatermarkPosition:
        item.attributes.images?.google?.watermark?.position ||
        item.attributes.images?.watermark?.position,
      hasLocalisationFields: hasLocalisationFields(item.attributes),
      hasEnhancedEventTicket:
        item.attributes.appleEnhancedDesign?.type === 'eventTicket',
      scheduledTemplateUpdate: item.attributes.scheduled_template_update,
      dynamicForm: hasDynamicForm(item),
    }));
  }
  return [];
}

export const buildPreviewDataFromPreset = (
  preset: TemplatePreset
): PreviewData => {
  const previewData = normalizedData([
    { id: preset.metadata.id, attributes: preset.template_data },
  ])[0] as Record<string, unknown>;

  return {
    ...previewData,
    hideIdPlaceholder: true,
    appleAppLink: previewData.appleAppLink ?? [],
    nfc: previewData.nfc ?? { enabled: false },
    barcode: previewData.barcode ?? { enabled: false },
  } as unknown as PreviewData;
};
